import React from "react";
import { MenuContainer } from "../../components/menuContainer/MenuContainer";
import { motion } from "framer-motion";
import styled from "styled-components";

const FacilityInfoWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 63px 20px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  justify-items: center;
  align-items: center;
  max-width: 100%;
  & > * {
    height: 100%;
    width: 100%;
  }
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 16px;
    gap: 30px 20px;
  }
`;

const FacilityWarp = styled.div`
  box-sizing: border-box;
  padding: 54px 37px;
  background-color: var(--bs-skyblue);
  border-radius: 10px;
  word-break: keep-all;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
  word-break: keep-all;
  @media (max-width: 768px) {
    padding: 15px 15px;
  }
`;

const FacilityIcon = styled.div`
  margin-bottom: 19px;
  margin-top: 35px;
`;

const Facilitytitle = styled.h3`
  color: #2d9adf;
  font-size: 24px;
  margin-bottom: 12px;
  font-weight: bold;
`;

const FacilitySize = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 22px;
`;

const FacilityDescription = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 180%;
  flex-grow: 1;
`;
const FacilityInfo = (props) => {
  return (
    <motion.div
      className="comment"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false }}
      transition={{
        ease: "easeInOut",
        duration: 1,
        y: { duration: 0.5 },
      }}
    >
      <FacilityWarp>
        <FacilityIcon>
          <img
            src={props.icon}
            alt="사무동 아이콘"
            // width="30"
            // height="30"
          />
        </FacilityIcon>
        <div className="divider">
          <style jsx>{`
            .divider {
              width: 40px;
              height: 4px;
              background-color: #2d9adf;
              margin-bottom: 10px;
            }
          `}</style>
        </div>
        <Facilitytitle>{props.title}</Facilitytitle>

        <FacilitySize>{props.size}</FacilitySize>

        <FacilityDescription
          dangerouslySetInnerHTML={{ __html: props.description }}
        ></FacilityDescription>
      </FacilityWarp>
    </motion.div>
  );
};

export const Facility = () => {
  return (
    <MenuContainer title="사업소개" menu="시설 개요" pointRadius="50%">
      <div className="comment-wrapper">
        <motion.div
          className="comment"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: "easeInOut",
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          “효율적이고 체계적인 공간으로
          <br />
          최고의 물류 솔류션을 제공합니다 ”
        </motion.div>
        <motion.div
          className="detailed-comment"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: "easeInOut",
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          넓은 부지와 최적화된 창고 시설을 통해 물류의 효율성을 극대화하고,
          <br />
          고객의 다양한 요구를 충족합니다.
        </motion.div>
      </div>
      <FacilityInfoWrap>
        <FacilityInfo
          icon={"/facility-icon-office.svg"}
          title={"사무동"}
          size={"165m²(50평)"}
          description={`사무동은 총 165m²(50평) 규모로
                <br />
                효율적인 업무 환경을 제공합니다.
                <br />
                최적의 사무 공간과 회의실을 갖추어
                <br />
                직원들의 업무 생산성을 높입니다.`}
        />
        <FacilityInfo
          icon={"/facility-icon-site-area.svg"}
          title={"부지면적"}
          size={"73,000m² (22,000평)"}
          description={`부지 면적은 총 73,000㎡(22,000평)로 <br/>
                넓고 체계적인 공간을 자랑합니다.<br/>
                물류창고와 포장야드를 포함해 <br/>
                물류 작업의 효율성을 극대화합니다.`}
        />
        <FacilityInfo
          icon={"/facility-icon-warehouse.svg"}
          title={"물류창고"}
          size={"19,500m² (5,900평)"}
          description={`물류창고는 총 19,500㎡(5,900평) 규모로<br/>
                최족의 보관 환경을 제공합니다.<br/>
                체계적인 물류 관리 시스템과 <br/>
                넓은 수용 공간으로<br/>
                효율적인 화물 관리를 지원합니다.`}
        />
        <FacilityInfo
          icon={"/facility-icon-extend.svg"}
          title={"증축예정"}
          size={"19,000m² (5,800평)"}
          description={`증축 예정 시설은 총 19,000㎡ (5,800평)의<br/>
                규모로 2025년 3월 완공을 <br/>
                목표로 하고 있습니다.<br/>
                고객 맞춤형 창고를 통해 더욱 다양한<br/>
                물류 수요를 지원할 예정입니다.`}
        />
        <FacilityInfo
          icon={"/facility-icon-packaging.svg"}
          title={"포장야드"}
          size={"46,200m² (14,000평)"}
          description={`포장야드는 46,200㎡(14,000평)의<br/>
                대규모 공간에서대형 화물 포장 및<br/>
                물류 작업이 진행됩니다,<br/>
                컨테이너 (20ft, 40ft)등 다양한 화물을<br/>
                신속하고 정확하게 처리합니다.<br/>`}
        />
      </FacilityInfoWrap>
    </MenuContainer>
  );
};
